import { IssueMode } from 'pages/Desk/issues/shared';
import { DefaultDeskStateValues } from 'pages/Desk/issues/state/initializer';
import {
    DeskState,
    DeskStateValues,
    StoredDeskStateValues,
} from 'pages/Desk/issues/state/types';
import { ISSUE_FILTER_VALIDATION_CONSTRAINTS } from 'shared/issue_filters_context/StoreUtils';
import { createCompositeStorageUtils } from 'shared/storage/createStorageUtils';
import { isValidSortArray } from 'shared/storage/validation';
import { getPartialObject, getPropertyNames } from 'utils/object';
import {
    isArray,
    isBoolean,
    isPartialObjectValid,
    isString,
    ObjectConstraints,
} from 'utils/object-validation';

const DeskStateValueConstraints: ObjectConstraints<DeskStateValues> = {
    isInitialized: isBoolean,
    ...ISSUE_FILTER_VALIDATION_CONSTRAINTS,
    sort: isValidSortArray,
    queuedIssueIds: (value) => isArray(value, isString),
};

export const getDeskStateValues = (state: DeskState): DeskStateValues =>
    getPartialObject(state, getPropertyNames(DeskStateValueConstraints));

const StoredDeskStateValueConstraints: ObjectConstraints<StoredDeskStateValues> = {
    ...DeskStateValueConstraints,
    locationId: (value) => value === undefined || isString(value),
};

export const isValidDeskState = (
    state: unknown,
): state is Partial<StoredDeskStateValues> =>
    isPartialObjectValid(state, StoredDeskStateValueConstraints);

const deskStorage = createCompositeStorageUtils<
    StoredDeskStateValues,
    [tab: string, mode: IssueMode]
>({
    baseKey: 'desk.state.storage',
    scopeGenerator: (tab, mode) => `${tab}.${mode}`,
    constraints: StoredDeskStateValueConstraints,
    defaults: DefaultDeskStateValues,
});

export const getDeskStorageKey = deskStorage.getStorageKey;
export const loadDeskStateFromBrowserStorage = deskStorage.load;
export const saveDeskStateToBrowserStorage = deskStorage.save;
export const clearDeskStateBrowserStorage = deskStorage.clear;
